import { useContext, useEffect } from "react";
import {
  UNSAFE_NavigationContext as NavigationContext,
  Navigator,
} from "react-router-dom";

type UsePromptProps = {
  when?: boolean;
  message?: string;
};

export const usePrompt = ({
  when = true,
  message = "Are you sure you want to leave?",
}: UsePromptProps): void => {
  const navigator = useContext(NavigationContext).navigator as Navigator & {
    push: (...args: any[]) => void;
  };

  useEffect(() => {
    if (!when) return;

    const originalPush = navigator.push;

    navigator.push = (...args: any[]) => {
      const confirmLeave = window.confirm(message);
      if (confirmLeave) {
        navigator.push = originalPush;
        originalPush(...args);
      }
    };

    return () => {
      navigator.push = originalPush;
    };
  }, [when, message, navigator]);
};
